import { render } from "./AlzataSideMenu.vue?vue&type=template&id=ce65ec6e"
import script from "./AlzataSideMenu.vue?vue&type=script&lang=js"
export * from "./AlzataSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__